import { Layout } from "../../layouts/v1";
import { MainView } from "../../views/return-exchange/root";

export function ReturnExchangePage(props) {
    return (
        <>
            <Layout>
                <MainView />
            </Layout>
        </>
    );
}